(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list-slideshow-swiperjs"] && !Shopify.designMode) return;
  try {
    
	var swiper = new Swiper('.swiper-container', {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4,
      slidesPerGroupSkip: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('next').onclick = function(){
    const widthItem = document.querySelector('.logolist--item').offsetWidth;
    document.getElementById('formList').scrollLeft += widthItem;
  }
  document.getElementById('prev').onclick = function(){
    const widthItem = document.querySelector('.logolist--item').offsetWidth;
    document.getElementById('formList').scrollLeft -= widthItem;
  }

  } catch(e) { console.error(e); }
})();
})();
